<template>
  <v-card flat class="sub-site-wrapper">
    <div>
      <v-container>
        <!-- Ladezustand -->
        <v-row v-if="loading">
          <v-col cols="12" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" md="6">
            <v-card class="pa-4 statistics-text-box elevation-3">
              <h4 class="mb-2">Allgemeine Nutzung</h4>
              <h5>
                Agenturen mit WhatsApp Zugang:
                {{ whatsAppUsage?.whatsappAccessCount?.[0]?.count || 0 }}
              </h5>
              <h5>
                <strong>Prozentualer Anteil (mind. 3 Slots):</strong>
                {{
                  whatsAppUsage?.whatsappAccessPercentage?.[0]?.percentage?.toFixed(
                    2
                  ) || 0
                }}%
              </h5>
            </v-card>
          </v-col>
        </v-row>

        <!-- Tabelle Agenturen -->
        <v-row>
          <v-col cols="6">
            <v-card class="statistics-text-box elevation-3">
              <v-card-title class="text-h6">
                Agenturen mit WhatsApp Verbindungen
              </v-card-title>
              <v-text-field
                class="content-data-search"
                flat
                v-model="search"
                label="Suche"
                prepend-inner-icon="mdi-magnify"
                variant="outlined"
                density="compact"
                hide-details
                single-line
                rounded="lg"
              ></v-text-field>
              <v-data-table
                :headers="headers"
                :items="filteredItems"
                :items-per-page="10"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td @click="openAgencyDialog(item._id)">
                      {{ item.companyName }}
                    </td>
                    <td class="text-center font-weight-bold">
                      {{ item.connectionsCount }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "WhatsAppUsageStatistics",
  components: {},
  created() {
    this.loadStatistics();
  },
  computed: {
    ...mapState("statistics", ["whatsAppUsage", "loading", "statisticsAge"]),
    filteredItems() {
      if (!this.search)
        return this.whatsAppUsage?.agenciesWithConnections || [];
      const searchLower = this.search.toLowerCase();
      return (this.whatsAppUsage?.agenciesWithConnections || []).filter(
        (item) => item.companyName.toLowerCase().includes(searchLower)
      );
    },
  },
  methods: {
    ...mapActions("statistics", ["fetchWhatsAppUsage"]),
    async loadStatistics() {
      await this.fetchWhatsAppUsage();
    },
    openAgencyDialog(_id) {
      this.$store.dispatch("agency/setDialogReturnRoute", this.$route.fullPath);
      this.$router.push({
        name: "agency",
        params: { agencyId: _id },
      });
    },
  },
  data() {
    return {
      search: "",
      headers: [
        { title: "Agentur", key: "companyName", sortable: true },
        {
          title: "Anzahl Verbindungen",
          key: "connectionsCount",
          sortable: true,
          align: "center",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.content-data-search {
  margin: 8px 0;
  border-radius: 12px;
  width: 100%;
}
</style>

